import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Niezłapany błąd aplikacji:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="sm" sx={{ py: 8 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>
              Wystąpił nieoczekiwany błąd
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Odśwież stronę, aby spróbować ponownie. Jeśli problem się powtarza, skontaktuj się z administratorem.
            </Typography>
            <Button variant="contained" onClick={this.handleReload}>
              Odśwież aplikację
            </Button>
          </Box>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
